import { normalize } from "normalizr";
import {classObject} from "./schema";

export const getClassList = {
  success: (response) => {
    return normalize(response, [classObject]);
  },
};
